/*
  Contagem regressiva do "carrinho reservado".

  O detalhe que define este componente: o cart drawer é re-renderizado inteiro a
  cada mudança de carrinho (cart.js troca o innerHTML de .drawer__inner), então
  ESTE elemento é destruído e recriado o tempo todo. Guardar o tempo restante no
  próprio elemento — como faz a referência — faz o relógio voltar para 05:00
  toda vez que o cliente mexe na quantidade, justo no momento em que a urgência
  deveria continuar. Por isso o prazo mora no sessionStorage.

  Também não acumulamos "menos 1 por tick": o valor vem sempre da diferença até
  o prazo, então aba em segundo plano (onde o setInterval é estrangulado) não
  atrasa o relógio.
*/
if (!customElements.get('cart-countdown')) {
  customElements.define(
    'cart-countdown',
    class CartCountdown extends HTMLElement {
      connectedCallback() {
        this.duration = parseInt(this.dataset.duration, 10) || 300;
        this.onEnd = this.dataset.onEnd || 'restart';
        this.storageKey = this.dataset.storageKey || 'cart-countdown-deadline';

        this.render(this.remaining());
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      /* sessionStorage e não localStorage: a reserva vale para esta visita. */
      deadline() {
        let stored = parseInt(sessionStorage.getItem(this.storageKey), 10);
        if (!stored || Number.isNaN(stored)) {
          stored = Date.now() + this.duration * 1000;
          this.store(stored);
        }
        return stored;
      }

      store(value) {
        try {
          sessionStorage.setItem(this.storageKey, String(value));
        } catch (error) {
          // Modo privado/cookies bloqueados: o timer segue, só não sobrevive
          // ao re-render. Melhor que quebrar o drawer.
        }
      }

      remaining() {
        return Math.max(0, Math.round((this.deadline() - Date.now()) / 1000));
      }

      tick() {
        const left = this.remaining();

        if (left > 0) {
          this.render(left);
          return;
        }

        if (this.onEnd === 'restart') {
          this.store(Date.now() + this.duration * 1000);
          this.render(this.duration);
          return;
        }

        this.render(0);
        clearInterval(this.interval);
        if (this.onEnd === 'hide') this.closest('.cart-timer')?.remove();
      }

      render(seconds) {
        const text = `${this.pad(Math.floor(seconds / 60))}:${this.pad(seconds % 60)}`;
        if (this.textContent === text) return;
        this.textContent = text;
      }

      pad(value) {
        return value < 10 ? `0${value}` : String(value);
      }
    }
  );
}
